// getCheckoutUrl returns the CO entry point URL for the current customer
// The clients must append its `sessionKey` as a query parameter, and may append a `version` query parameter
export const CheckoutV1_getCheckoutUrlLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_getCheckoutUrl);
CheckoutV1_getCheckoutUrlLazy.method =
  "checkout.CheckoutV1/getCheckoutUrl" as const;

// getCheckoutDetails returns the data used to initialize the checkout web component.
export const CheckoutV1_getCheckoutDetailsLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_getCheckoutDetails);
CheckoutV1_getCheckoutDetailsLazy.method =
  "checkout.CheckoutV1/getCheckoutDetails" as const;

// signInWithApple signs in the user with Apple, either logging into an existing account or creating a new one
export const CheckoutV1_signInWithAppleLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_signInWithApple);
CheckoutV1_signInWithAppleLazy.method =
  "checkout.CheckoutV1/signInWithApple" as const;

// logInWithEmail signs into an existing account using email and password
export const CheckoutV1_logInWithEmailLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_logInWithEmail);
CheckoutV1_logInWithEmailLazy.method =
  "checkout.CheckoutV1/logInWithEmail" as const;

// registerWithEmail creates a new account for an email-based login
//
// In case an account with the email/password already exists, we will try to login with the credentials
export const CheckoutV1_registerWithEmailLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_registerWithEmail);
CheckoutV1_registerWithEmailLazy.method =
  "checkout.CheckoutV1/registerWithEmail" as const;

// logInWithFacebook signs in the user using Facebook, either logging into an existing account or creating a new one
//
// In case no email address can be retrieved for the given token from the Graph API, this returns an error with code `FailedPrecondition`
// and details of type PreconditionFailure, with a single failure with `Type = "NoEmail"`.
// Clients should inform the user that they need to associate an email addres with their Facebook account to proceed in this case.
export const CheckoutV1_logInWithFacebookLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_logInWithFacebook);
CheckoutV1_logInWithFacebookLazy.method =
  "checkout.CheckoutV1/logInWithFacebook" as const;

// linkList merges the given list from a previous guest session onto the current customer
export const CheckoutV1_linkListLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_linkList);
CheckoutV1_linkListLazy.method = "checkout.CheckoutV1/linkList" as const;

// logout logs a customer out of Checkout and removes their API token from the Mobile Token redis
export const CheckoutV1_logoutLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_logout);
CheckoutV1_logoutLazy.method = "checkout.CheckoutV1/logout" as const;

// forgetPassword sends an email with a link for reseting the user password
export const CheckoutV1_forgetPasswordLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_forgetPassword);
CheckoutV1_forgetPasswordLazy.method =
  "checkout.CheckoutV1/forgetPassword" as const;

// resetPassword resets the password for a customer
export const CheckoutV1_resetPasswordLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_resetPassword);
CheckoutV1_resetPasswordLazy.method =
  "checkout.CheckoutV1/resetPassword" as const;

// UpdateCustomer updates the provided data on the Customer and returns the new customer data
//
// In case the endpoint returns an `codes.InvalidArgument`, the error details contain a `google.rpc.BadRequest` message describing the fields that failed.
export const CheckoutV1_UpdateCustomerLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_UpdateCustomer);
CheckoutV1_UpdateCustomerLazy.method =
  "checkout.CheckoutV1/UpdateCustomer" as const;

// getCustomer returns the current Checkout Customer (also see `Customer.getCustomer` to get the BI customer data)
export const CheckoutV1_getCustomerLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_getCustomer);
CheckoutV1_getCustomerLazy.method = "checkout.CheckoutV1/getCustomer" as const;

export const CheckoutV1_createOrderBasketLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_createOrderBasket);
CheckoutV1_createOrderBasketLazy.method =
  "checkout.CheckoutV1/createOrderBasket" as const;

export const CheckoutV1_getOrderBasketLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_getOrderBasket);
CheckoutV1_getOrderBasketLazy.method =
  "checkout.CheckoutV1/getOrderBasket" as const;

export const CheckoutV1_addVoucherToOrderBasketLazy = () =>
  import("./checkout_v1.grpc").then(
    (m) => m.CheckoutV1_addVoucherToOrderBasket
  );
CheckoutV1_addVoucherToOrderBasketLazy.method =
  "checkout.CheckoutV1/addVoucherToOrderBasket" as const;

export const CheckoutV1_deleteVoucherFromOrderBasketLazy = () =>
  import("./checkout_v1.grpc").then(
    (m) => m.CheckoutV1_deleteVoucherFromOrderBasket
  );
CheckoutV1_deleteVoucherFromOrderBasketLazy.method =
  "checkout.CheckoutV1/deleteVoucherFromOrderBasket" as const;

export const CheckoutV1_DeleteCustomerLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_DeleteCustomer);
CheckoutV1_DeleteCustomerLazy.method =
  "checkout.CheckoutV1/DeleteCustomer" as const;

export const CheckoutV1_HasValidSessionLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_HasValidSession);
CheckoutV1_HasValidSessionLazy.method =
  "checkout.CheckoutV1/HasValidSession" as const;

export const CheckoutV1_GetAccessTokenLazy = () =>
  import("./checkout_v1.grpc").then((m) => m.CheckoutV1_GetAccessToken);
CheckoutV1_GetAccessTokenLazy.method =
  "checkout.CheckoutV1/GetAccessToken" as const;
